export const useHeader = ()=> useState<object>('header', () => { 
    return  {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
    };
});
export const useData = ()=> useState<object>('localData', () => null);
export const useLocale = ()=> useState<string>('locale', () => 'tr');
export const useUser = ()=> useState<object>('user', () => null);
export const useUsers = ()=> useState<object>('users', () => null);
// An OAuth callback returns through a full-page redirect, so its pending MFA
// challenge must be shared with the login page rather than held in a local ref.
export const useAdminMfaChallenge = ()=> useState<object>('admin-mfa-challenge', () => null);
export const useContactForm = ()=> useState<object>('contactForm', () => {
    return {
        show: false,
        id: null,
        data: {
            name: '',
            subject: '',
            mobile:'',
            email: '',
            message:'',
            id: null
        },
        minimize: false,
    }
});
export const useAlert = ()=> useState<object>('alert', () => { return { show: false, type:'',text:'',title:''}});

export const usePageData = () => useState<object>('pageData', () => {
    return {
        id:null
    }
});

export const useReservation = () => useState<object>('RESERVATİON', () => {
    return {
  room: 1,
  rooms: [
    {
      adult: 2,
      child: 0,
      baby: 0,
      room_type: null,
      options: {}
    }
    ],
    childrenAges: []
}
});
export const useIsMobile = () => useState<boolean | null>('isMobile', () => null)
export const useTourCompare = () => useState<object>('tour_compare', () => {
    return {
        open: false,
        items: []
    }
});
export const useGoogleMap = () => useState<google.maps.Map | undefined>("google_map", undefined);
export const useGoogleMapHTML = () => useState<HTMLElement | undefined>("google_map_html", undefined);

export const initializeGoogleMap = (map_html: HTMLElement): void => {
    if (!useGoogleMapHTML().value) {
        console.error("google_map_html is not defined");
        return;
    }

    // Initialize Google Map
    useGoogleMap().value = new google.maps.Map(map_html as HTMLElement, {
        center: { lat: 60, lng: 40 }, // Default map view position
        zoom: 4, // Default zoom

        styles: [
            {
                featureType: "poi",
                stylers: [{ visibility: "off" }],
            },
        ],

        clickableIcons: false,
        streetViewControl: false,
        mapTypeControl: false,
        draggableCursor: "crosshair",
        fullscreenControl: false,
        minZoom: 2,

        restriction: {
            latLngBounds: {
                north: 85,
                south: -85,
                west: -180,
                east: 180,
            },
        },

        gestureHandling: "greedy", // Does not need 2 fingers to move on map when using touchscreen (Not working on Firefox Mobile. Safari, not sure.)
        keyboardShortcuts: false,
    });
};

// Function used to center Google Map to specific coordinates
export const centerGoogleMap = (lat: number, lng: number): void => {
    const googleMap = useGoogleMap().value;

    if (!googleMap) {
        console.error("google_map is not defined");
        return;
    }

    googleMap.setCenter({ lat, lng });
};
 
